//App
import { EmployeeContext } from "../EmployeeContainer";
import {
  OrganizationEmployeeContextData,
  OrganizationEmployeeProps,
} from "../../../types/organizationEmployee";
import useForm from "../../hooks/useForm";
const useEmployee = (props: OrganizationEmployeeProps) => {
  return useForm<OrganizationEmployeeContextData, OrganizationEmployeeProps>(
    EmployeeContext,
    props
  );
};

export default useEmployee;
